import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IBcContestCourse } from '../../../models/BcContest';

import { AppService } from '../../../services/app.service';
import { BcContestService } from '../../../services/bc-contest.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { BcContestApplicationsComponent } from '../applications/bc-contest-applications.component';
import { bcState } from '../shared';

@Component({
    selector: 'app-bc-contest-courses',
    templateUrl: './bc-contest-courses.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestCoursesComponent {
    constructor(
        private app: AppService,
        private service: BcContestService,
        private modal: NgbModal
    ) { }

    @Input() set key(value: number) {
        this.load();
    }

    @Input() contestId: number;

    readonly columns: ITableColumn[] = [
        { property: 'Code', label: 'bcContestCourse_lblCode', sorts: true },
        { property: 'Name', label: 'bcContestCourse_lblName', sorts: true },
        { property: 'PlanningPeriod', label: 'bcContestCourse_lblPlanningPeriod', sorts: true },
        { property: 'StudyProgram', label: 'bcContestCourse_lblStudyProgram', sorts: true },
        { property: 'GroupMaxSize', label: 'bcContestCourse_lblGroupMaxSize', sorts: true, type: 'number' },
        { property: 'ApplicationCount', label: 'bcContestCourse_lblApplicationCount', sorts: true, type: 'number' },
        { property: 'InApplicationCount', label: 'bcContestCourse_lblInApplicationCount', sorts: true, type: 'number' },
        { width: '1px' }
    ];

    items: IBcContestCourse[] = [];

    private allItems: IBcContestCourse[] = [];

    openApplications(course: IBcContestCourse) {
        const ref = this.modal.open(BcContestApplicationsComponent, { size: 'lg' });

        ref.componentInstance.data = {
            contestId: this.contestId,
            course: {
                id: course.Id,
                code: course.Code,
                name: course.Name
            }
        };
    }

    filter(term: string) {
        if (!term) {
            this.items = [...this.allItems];
        } else {
            const s = term.toLowerCase();

            this.items = this.allItems.filter(t => {
                return t.Code?.toLowerCase().includes(s) || t.Name?.toLowerCase().includes(s);
            });
        }
    }

    private load() {
        const cached = bcState.getCourses();

        if (cached) {
            this.items = cached;
            this.allItems = cached;
        } else {
            this.app.addLoading(this.service.getCourses(this.contestId)).subscribe(data => {
                this.items = data;
                this.allItems = data;

                bcState.setCourses(data);
            });
        }
    }
}
